module.exports = __webpack_public_path__ + "static/media/logout.2ddd7564.svg";